import React from 'react';
import ReactDOM from 'react-dom';
import { AppRoute } from "./routes";
import * as serviceWorker from './serviceWorker';
import {Provider} from "react-redux";
import store from "./redux/store/store";
import setupAxiosInterceptors from "./utils/setupAxiosInterceptors";

// 401 alindiginda oturumu sonlandirip girise yonlendirir (tek yerden).
setupAxiosInterceptors(store);

const render = Component => ReactDOM.render(
    <Provider store={store}>
        <Component/>
    </Provider>,
    document.getElementById('root')
);

render(AppRoute);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
